<template>
  <div class="v-select-menu max-w-full">
    <v-select
      :id="id"
      v-model="selectOption"
      :placeholder="placeholder"
      :options="options"
      :searchable="false"
      :clearable="false"
      :filterable="false"
      :required="required"
      :data-testid="testId"
      class="v-select-custom"
      :class="{
        'v-select-custom--above': openAbove,
        'v-select-custom--themed': themed,
        'v-select-custom--small': small,
        'v-select-custom--large': large,
      }"
      :components="{ OpenIndicator }"
    />
  </div>
</template>

<script>
export default {
  name: "SelectMenu",

  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: null,
    },
    openAbove: {
      type: Boolean,
      default: false,
    },
    themed: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: null,
    },
    testId: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      OpenIndicator: {
        render: (createElement) => createElement("span", { class: "caret" }),
      },
    };
  },

  computed: {
    selectOption: {
      get() {
        return this.options.find(({ value }) => value === this.value);
      },
      set({ value }) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
